import React, { useState, useRef } from "react";

import { formatNumber, enviarDatos } from './functions.js';

const MotoFunnel = () => {
  //const [session, setSession] = useState(1);
  const [session, setSession] = useState(crypto.randomUUID());
  const [selectedMoto, setSelectedMoto] = useState(1);
  const [cuotaInicial, setCuotaInicial] = useState(0);
  const [mesesCredito, setMesesCredito] = useState(1);
  const [tasaInteres, setTasaInteres] = useState(0.05); // Tasa del 5% mensual
  const [whatsapp, setWhatsapp] = useState("");
  const [nombre, setNombre] = useState("");
  const [fecnac, setFecnac] = useState("");
  
  const [telefono, setTelefono] = useState("");
  const [mostrarResultado, setMostrarResultado] = useState(false);
  const [resultado, setResultado] = useState(null);
  const resultadoRef = useRef(null);
  const id_comercio = 1;


  // selectedMoto, cuotaInicial, mesesCredito, tasaInteres, whatsapp, nombre, fecnac, telefono, session
  // id_comercio = 1 
  // Opciones de motos
  const motos = [
    { idm: 1, modelo: "Modelo 1", imagen: "images/img1.jpg", precio: 10000000 },
    { idm: 2, modelo: "Modelo 2", imagen: "images/img2.jpg", precio: 20000000 },
    { idm: 3, modelo: "Modelo 3", imagen: "images/img3.jpg", precio: 25000000 },
  ];

  // Fórmula de PAGO()
  const calcularPago = (monto, tasa, periodos) => {
    return (tasa * monto) / (1 - Math.pow(1 + tasa, -periodos));
  };

  const obtenerPrecio = (modeloBuscado) => {
    //console.log("modeloBuscado "+modeloBuscado);
    const moto = motos.find((moto) => moto.idm === Number(modeloBuscado));
    return moto ? moto.precio : 0;
  };

  let precioMoto = obtenerPrecio(selectedMoto);
  //const session = crypto.randomUUID();

  const handleCalcular = () => {
    
    handleAceptar()

    if (cuotaInicial >= 0) {
      
      precioMoto = obtenerPrecio(selectedMoto); // Precio de la moto
      
      const montoCredito = precioMoto - cuotaInicial;
      const pagoMensual = calcularPago(montoCredito, tasaInteres, mesesCredito);
      
      setResultado(`${formatNumber(pagoMensual)}`);
      /* pagoMensual.toFixed(2) */
      if (nombre != "" || telefono != "") {
        setMostrarResultado(true);
        // Hacer scroll hacia el div con el id "resultado"
        if (resultadoRef.current) {
          resultadoRef.current.scrollIntoView({ behavior: "smooth" });
        }

        const id_comercio = 1; //  Demo

        const data = {
          selectedMoto,
          cuotaInicial,
          mesesCredito,
          tasaInteres,
          whatsapp,
          nombre,
          fecnac,
          session,
          id_comercio
      };
  
      enviarDatos(data);        

      } else {
        setMostrarResultado(false);
      }
    }
  };

  const handleAceptar = () => {
    var nombre = document.getElementById("nombre").value;
    var telefono = document.getElementById("telefono").value;
    if (nombre == "" || telefono == "") {
      alert("Porfavor coloque su NOMBRE y TELÉFONO")
      return;
    }
    //setMostrarResultado(true); // Ahora se mostrará el resultado
  };

  const handlePrecio = () => {
    document.getElementById("precio").value = precioMoto;
  };


  return (
    <div className="container" style={{ maxWidth: '500px', padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <center><img src="images/logo.jpg" /></center><br />
      <center><h3>NOMBRE DE SU NEGOCIO</h3></center>
      <hr />

      <span><b>Calcule las cuotas de sus pagos</b></span><br /><br />


      {/* Selección del modelo de moto */}
      <label htmlFor="moto-select">Selecciona un modelo:</label>
      <select
        id="moto-select"
        value={selectedMoto}  
        onChange={(e) => { setSelectedMoto(e.target.value); handlePrecio(); setMostrarResultado(false); }}
        style={{ display: "block", margin: "10px 0" }}
        className="form-select"
      >
        {motos.map((moto, index) => (
          <option key={index} value={moto.idm}>
            {moto.modelo}
          </option>
        ))}
      </select>

      {/* Imagen de la moto seleccionada */}
      <div style={{ marginBottom: "20px", height: "200px" }}>
        <img
          src={motos.find((moto) => moto.idm === Number(selectedMoto)).imagen}
          alt={selectedMoto}
          style={{ height: "100%", objectFit: "cover" }}
        />
      </div>
      <div id="precio" className="mb-4"><b>PRECIO $ {formatNumber(precioMoto)}</b></div>
      {/* Campo de entrada para la cuota inicial */}
      <label htmlFor="cuota-inicial">Cuota Inicial:</label>
      <input
        type="number"
        id="cuota-inicial"
        value={cuotaInicial}
        onChange={(e) => setCuotaInicial(parseFloat(e.target.value))}
        style={{ display: "block", margin: "10px 0" }}
        className="form-control"
      />

      {/* Selección de meses de crédito */}
      <label htmlFor="meses-credito">Meses del crédito:</label>
      <select
        id="meses-credito"
        value={mesesCredito}
        onChange={(e) => setMesesCredito(parseInt(e.target.value, 10))}
        style={{ display: "block", margin: "10px 0" }}
        className="form-control"
      >
        {Array.from({ length: 48 }, (_, i) => i + 1).map((mes) => (
          <option key={mes} value={mes}>
            {mes}
          </option>
        ))}
      </select>

      {/* Tasa de interés */}
      <label>Tasa de interés:</label>
      <input
        type="text"
        value={`${(tasaInteres * 100).toFixed(2)}%`}
        readOnly
        style={{ display: "block", margin: "10px 0" }}
        className="form-control"
      />
      <label>Nombre:</label>
      <input
        id="nombre"
        type="text"
        placeholder="Su nombre"
        value={nombre}
        onChange={(e) => setNombre(e.target.value)}
        style={{ display: "block", margin: "10px 0" }}
        className="form-control" required
      />

      <label>Fecha de Nacimiento:</label>
      <input
        id="fecha"
        type="date"
        placeholder="Fecha de nacimiento"
        value={fecnac}
        onChange={(e) => setFecnac(e.target.value)}
        style={{ display: "block", margin: "10px 0" }}
        className="form-control" required
      />


      <label>Teléfono:</label>
      <input
        id="telefono"
        type="tel"
        placeholder="Número de WhatsApp"
        value={whatsapp}
        onChange={(e) => setWhatsapp(e.target.value)}
        style={{ display: "block", margin: "10px 0" }}
        className="form-control" required
      />
      

      {/* Botón Calcular */}
      <a href="#masinfo" className="btn btn-primary" onClick={handleCalcular} style={{ marginBottom: "20px" }}>
        Calcular
      </a>

      {/* Input para WhatsApp
      {!mostrarResultado && resultado && (

      )}   */}

      
      {/* Resultado del cálculo */}
      {mostrarResultado && resultado && (
        <div id="resultado"
          style={{
            marginTop: "20px",
            padding: "10px",
            border: "1px solid #ddd",
            backgroundColor: "#f9f9f9",
          }}
        >
          <h3>Resultado</h3>
          <p>El pago mensual será de <b>$ {resultado}</b></p>
        </div>        
      )}

      <div id="masinfo" ref={resultadoRef} className="mt-4">
        <a href={`https://wa.me/573123162422?text=Hola%20quiero%20mas%20info%20sobre%20${selectedMoto}`}  className="btn btn-success" target="_blank" >
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-whatsapp" viewBox="0 0 16 16">
          <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
        </svg> Quiero mas información</a>
      </div>

    </div>
  );
};

export default MotoFunnel;




